import { forwardRef } from "react";
import { TextField, type TextFieldProps } from "./TextField";

/** Texto parcial válido mientras se escribe: hasta 3 enteros, coma o punto, hasta 4 decimales. */
const PARCIAL = /^\d{0,3}([.,]\d{0,4})?$/;

export interface PercentFieldProps extends Omit<TextFieldProps, "value" | "onChange" | "type" | "inputMode"> {
  valor: string;
  onCambio: (valor: string) => void;
}

/** Input de porcentaje. El valor queda como texto (nunca float): para sumar usar lib/participacion. */
export const PercentField = forwardRef<HTMLInputElement, PercentFieldProps>(function PercentField({ valor, onCambio, ...props }, ref) {
  return (
    <TextField
      ref={ref}
      {...props}
      type="text"
      inputMode="decimal"
      autoComplete="off"
      value={valor}
      onChange={(e) => {
        const nuevo = e.target.value.trim();
        if (PARCIAL.test(nuevo)) onCambio(nuevo);
      }}
    />
  );
});
